var _desc, _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602.05127,
    height: 549.095642,
    viewBox: "0 0 602.051 549.096",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M602.05 17.9C583.02 53.15 564.56 87.1 545.76 122.16C542.57 128.12 541.38 128.04 534.86 126.52C456.48 109.87 372.99 111.77 295.53 131.46C188.79 156.52 79.81 227.21 53.18 339.69C35.05 426.64 69.16 497.37 139.46 548.26C-47.27 470.51 -36.8 227.29 113.29 116.2C245.8 7.49 438.74 -24.12 602.05 17.9Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M448.69 305.56C366.57 293.36 279.02 292.55 204.81 335.61C143.31 367.43 107.5 449.86 148.68 510.88C156.5 527.68 172.97 533 181.74 549.09C79.71 499.11 69.32 361.3 148.18 285.44C238.6 193.58 380.65 189.54 500.44 208.69C498.43 218.46 458.57 292.67 448.69 305.56Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M212.26 543.9C149.88 486.34 173.28 407.92 251.58 381.12C306.44 363.7 366.37 361.21 421.71 375.66C386.13 435.52 414.2 425.45 348.32 417.87C302.46 413.39 228.14 421.08 204.33 466.49C188.52 495.53 205.42 517.68 212.26 543.9Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKop);
export default __webpack_public_path__ + "static/media/kop.e7b86e0d162bbfc77cbc38fcaca7c3a0.svg";
export { ForwardRef as ReactComponent };